export default __webpack_public_path__ + "static/media/5.e8c96aa6.jpg";